/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Why_Largest_DescInputs */

const en_landing_why_largest_desc = /** @type {(inputs: Landing_Why_Largest_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ideogram demonstrated editing a 24.2-megapixel source without downsizing it.`)
};

const zh_landing_why_largest_desc = /** @type {(inputs: Landing_Why_Largest_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ideogram 演示了在不缩小的情况下编辑 2420 万像素源图。`)
};

/**
* | output |
* | --- |
* | "Ideogram demonstrated editing a 24.2-megapixel source without downsizing it." |
*
* @param {Landing_Why_Largest_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_why_largest_desc = /** @type {((inputs?: Landing_Why_Largest_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Why_Largest_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_why_largest_desc(inputs)
	return zh_landing_why_largest_desc(inputs)
});
export { landing_why_largest_desc as "landing.why.largest_desc" }